import { RefObject } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotification, useTranslate } from "@refinedev/core";

import { ModalRef } from "@shared/components";
import { useEditMagazineTemplateMutation } from "@modules/magazineTemplates/services/mutations";
import { MagazineTemplateFormValues, magazineTemplateSchema } from "@modules/magazineTemplates/validations";

export function useEditMagazineTemplateModal(modalRef: RefObject<ModalRef>, onComplete?: () => void) {
  const translate = useTranslate();
  const { open } = useNotification();

  const methods = useForm<MagazineTemplateFormValues>({
    resolver: zodResolver(magazineTemplateSchema()),
    mode: "onBlur",
  });

  const { mutateAsync, isPending } = useEditMagazineTemplateMutation({
    onSuccess: () => {
      onComplete?.();
      open?.({
        type: "success",
        message: translate("magazine/magazine_template_admin.success.edit"),
      });

      modalRef.current?.close();
    },
  });

  const handleSubmit = async (data: MagazineTemplateFormValues) => {
    const magazinetemplateId = modalRef.current?.getId();
    await mutateAsync({ id: magazinetemplateId as string, data });
  }

  return {
    methods,
    isPending,
    handleSubmit,
  };
}
